import React from 'react';
import styled from 'styled-components';

import { H1 } from './headings';
import { colorScheme } from '../../theme';
import { Card } from './card';

interface State {
  error: any;
  showDetails: boolean;
}

export class ErrorBoundary extends React.Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = { error: null, showDetails: false };
  }

  static getDerivedStateFromError(error: any) {
    console.log({ error });
    return { error };
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.info(error, errorInfo);
  }

  format = (msg: string) => {
    let res = JSON.stringify(msg, null, 4);
    res = res.replaceAll('\\n', '\n');
    return res;
  };

  showDetails = () => this.setState({ showDetails: true });

  render() {
    const { error, showDetails } = this.state;

    if (error) {
      return (
        <Container>
          <H1>Oh my! We've caught an error.</H1>
          {!showDetails ? (
            <P onClick={this.showDetails}>
              Click <span>here</span> for more details.
            </P>
          ) : (
            <>
              <P>Here's what happened:</P>
              <Pre>{this.format(this.state.error.message)}</Pre>
              <Pre>{this.format(this.state.error.stack)}</Pre>
            </>
          )}
        </Container>
      );
    }

    return this.props.children;
  }
}

const Container = styled(Card)`
  display: block;
  margin: 0 auto;
  padding: 3em;
  max-width: 80em;
  border-radius: 4px;
`;

const Pre = styled.pre`
  max-height: 300px;
  overflow: auto;
  max-width: 100%;

  white-space: pre-line;
  color: ${colorScheme.text.base};
  border: 1px solid ${colorScheme.card.border};
  padding: 1em;
`;

const P = styled.p`
  margin-top: 1em;

  span {
    cursor: pointer;
    text-decoration: underline;
  }
`;
